import { templateKey, title, body, headImage } from './fields'

const choirFields = [templateKey, headImage, title, body]

export const choirEN = {
    file: "src/pages/choirleader/index.en.md",
    label: "Choirleader English",
    name: "choirleader english",
    fields: choirFields
}

export const choirDE = {
    file: "src/pages/choirleader/index.de.md",
    label: "Choirleader German",
    name: "choirleader german",
    fields: choirFields
}

export const bioEN = {
    file: "src/pages/bio/index.en.md",
    label: "Bio English",
    name: "bio english",
    fields: choirFields
}

export const bioDE = {
    file: "src/pages/bio/index.de.md",
    label: "Bio German",
    name: "bio german",
    fields: choirFields
}

export const projectsEN = {
    file: "src/pages/projects/index.en.md",
    label: "Projects English",
    name: "projects english",
    fields: choirFields
}

export const projectsDE = {
    file: "src/pages/projects/index.de.md",
    label: "Projects German",
    name: "projects german",
    fields: choirFields
}

export const arrangementsEN = {
    file: "src/pages/arrangements/index.en.md",
    label: "Arrangements English",
    name: "arrangements english",
    fields: choirFields
}

export const arrangementsDE = {
    file: "src/pages/arrangements/index.de.md",
    label: "Arrangements German",
    name: "arrangements german",
    fields: choirFields
}